import { courses } from './courses';

const courseByTitle = (title) => courses.find((c) => c.title === title);

// Upcoming live cohorts. Update dates and schedules here as new batches open.
export const cohorts = [
  {
    id: 'fullstack-nov-2026',
    course: courseByTitle('Full-Stack Web Development'),
    startDate: '2026-11-09',
    schedule: 'Mon – Fri · 8:00 – 10:00 PM IST',
    batch: 'Weekday',
    duration: '6 months'
  },
  {
    id: 'java-nov-2026',
    course: courseByTitle('Java Full-Stack'),
    startDate: '2026-11-14',
    schedule: 'Sat & Sun · 10:00 AM – 1:00 PM IST',
    batch: 'Weekend',
    duration: '6 months'
  },
  {
    id: 'dsa-nov-2026',
    course: courseByTitle('Data Structures & Algorithms'),
    startDate: '2026-11-16',
    schedule: 'Mon, Wed, Fri · 9:00 – 10:30 PM IST',
    batch: 'Weekday',
    duration: '4 months'
  },
  {
    id: 'system-design-dec-2026',
    course: courseByTitle('System Design'),
    startDate: '2026-12-05',
    schedule: 'Sat & Sun · 6:00 – 8:00 PM IST',
    batch: 'Weekend',
    duration: '3 months'
  },
  {
    id: 'agentic-ai-dec-2026',
    course: courseByTitle('Agentic AI'),
    startDate: '2026-12-07',
    schedule: 'Tue & Thu · 8:00 – 10:00 PM IST',
    batch: 'Weekday',
    duration: '3 months'
  }
];

export const formatDate = (isoDate) =>
  new Date(`${isoDate}T00:00:00`).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
